import React, { useEffect } from "react";
import { Modal, Form, Input, message } from "antd";
import api from "../api";

const ExportadorModal = ({ open, exportador, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const isEdit = !!exportador;

  useEffect(() => {
    if (open) {
      if (isEdit && exportador) {
        form.setFieldsValue({
          identificacion: exportador.identificacion,
          nombre: exportador.nombre,
          mail: exportador.mail,
          observaciones: exportador.observaciones,
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, isEdit, exportador, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (isEdit) {
        await api.put(`/exportadores/${exportador.idexportadores}`, values);
        message.success("Exportador actualizado exitosamente");
      } else {
        await api.post("/exportadores", values);
        message.success("Exportador agregado exitosamente");
      }
      form.resetFields();
      onSuccess();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        message.error(error.response.data.message);
      } else {
        message.error("Error al guardar exportador");
      }
    }
  };

  return (
    <Modal
      title={isEdit ? "Editar Exportador" : "Nuevo Exportador"}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Guardar"
      cancelText="Cancelar"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="identificacion"
          label="Identificación"
          rules={[{ required: true, message: "La identificación es obligatoria." }]}
        >
          <Input placeholder="Ej. 1234567890" />
        </Form.Item>

        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[{ required: true, message: "El nombre es obligatorio." }]}
        >
          <Input placeholder="Ej. Exportaciones SA" />
        </Form.Item>

        <Form.Item
          name="mail"
          label="Correo"
        >
          <Input placeholder="Ej. contacto@exportaciones.com" type="email" />
        </Form.Item>

        <Form.Item
          name="observaciones"
          label="Observaciones"
        >
          <Input.TextArea placeholder="Comentarios adicionales..." />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ExportadorModal;
